import type { NextPage } from "next";
import PageLayout from "../components/PageLayout";

import useLedgerCookies from "@hooks/useLedgerCookies";

import ClaimEL from "@components/ClaimEL";

const ClaimELPage: NextPage = () => {
  useLedgerCookies();
  return (
    <PageLayout>
      <ClaimEL />
    </PageLayout>
  );
};

export default ClaimELPage;
